import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ORGANIZATION_PERSON_PROFILE_MODAL';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (organizationId: string, organizationPersonId: string) => ({organizationId, organizationPersonId}),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: toggleEdit} = createAction(`${domain}/TOGGLE_EDIT`, () => ({}));

export const {
    action: submit,
    success: submitSuccess,
    failed: submitFailed,
} = createAction(
    `${domain}/SUBMIT`,
    (organizationId: string, organizationPersonId: string, name: string, email: string) => ({
        organizationId,
        organizationPersonId,
        name,
        email,
    }),
    () => ({}),
);
